<template>


    <div class="container-3">
      <div class="container-3-left">

        <div>
          <router-link to="/SpicyBowls"> 
            <button class="text-spicy-bowls">Spicy Bowls</button>
          </router-link>
        </div>

        <div>
          <router-link to="/JapchaeTteokbokki"> 
            <button class="text-japchae-tteokbokki">Japchae & Tteokbokki</button>
          </router-link>
        </div>

        <div>
          <router-link to="/Jjigae"> 
            <button class="text-jjigae">Jjigae</button>
          </router-link>
        </div>

        <div>
          <router-link to="/Soup"> 
            <button class="text-soup">Soup</button>
          </router-link>
        </div>

      </div>


      <div class="container-3-right">
        <div id="slider">
          <figure>
            <img src="../assets/Japchae.png">
            <img src="../assets/Tteokbokki.png">
            <img src="../assets/JjigaeTofu.png"> 
            <img src="../assets/SoupMussel.png">   
            <img src="../assets/Japchae.png">
          </figure>
        </div>
      </div>

    </div>

  <router-view/>


</template>

<script>

  export default {
    name: 'HomeBody3'
  }

</script>
  
<style scoped>



/* for bigger screen */
@media (min-width:700px) {

/* 3rd Container */
  .container-3 {
    display: grid;
    grid-template-columns: 2fr 1fr 0.1fr;
    background-color: rgb(238, 238, 238);
    height: 25vw;
    margin-top: 0.7rem;
  }


  .text-spicy-bowls {
    cursor: pointer;
    border: none;
    outline: none;
    color: darkblue;
    font-style: optima;
    font-size: 1.4rem;
    font-weight: bold;
    line-height: 1vw;
    margin-top: 6vw;
    margin-left: -30vw;
  }

  .text-japchae-tteokbokki {
    cursor: pointer;
    border: none;
    outline: none;
    color: darkblue;
    font-style: optima;
    font-size: 1.4rem;
    font-weight: bold;
    line-height: 1vw;
    margin-top: 2vw;
    margin-left: 0vw;
  }


  .text-jjigae {
    cursor: pointer;
    border: none;
    outline: none;
    color: darkblue;
    font-style: optima;
    font-size: 1.4rem;
    font-weight: bold;
    line-height: 1vw;
    margin-top: 2vw;
    margin-left: 10vw;
  }

  .text-soup {
    cursor: pointer;
    border: none;
    outline: none;
    color: darkblue;
    font-style: optima;
    font-size: 1.4rem;
    font-weight: bold;
    line-height: 1vw;
    margin-top: 2vw;
    margin-left: 30vw;
  }


.container-3-right {
    place-items: center;    
    width: 82%;
    height: 25vw;
    margin: auto;
  }

  #slider {
    overflow: hidden;
  }

  #slider figure {
    position: relative;
    width: 500%;
    height: 100%;
    margin: 0;
    left: 0;
    object-fit: cover;
    animation: 30s slider infinite; 
  } 

  #slider figure img {
    float: left;
    width: 20%;  /* 100 / 5 including last image (dup of image1) */ 
    transform: translate3d(0, 0, 0); /* prevents potential flickering on some browsers */
    backface-visibility: hidden;
  }


@keyframes slider {

    /* Calculation: Each image is displayed for 5s (static) and move in 1s (transition)
       Total steps are 7 (including the duplicate), but we have 6 transitions
       Each image's stop point percentage is (index * 6s / 30s * 100%)
       Move point is (index * 6s - 1s / 30s * 100%)
    */

    /* image 1: End hold at 5s */
    0% {transform: translateX(0);}
    16.67% {transform: translateX(0);} /* 5s/30s*100, stay at 0% */
    20% {transform: translateX(-20%);} /* 6s/30s*100, move to image 2 */


    /* Image 2: End hold at 11s, move to image 3 at 12s */
    36.67% {transform: translateX(-20%);} /* 11s/30s*100 */
    40% {transform: translateX(-40%);} /* 12s/30s*100 */


    /* Image 3: End hold at 17s, move to image 4 at 18s */
    56.67% {transform: translateX(-40%);} /* 17s/30s*100 */
    60% {transform: translateX(-60%);} /* 18s/30s*100 */

    /* Image 4: End hold at 23s, move to image 5 at 24s */
    76.67% {transform: translateX(-60%);} /* 23s/30s*100 */
    80% {transform: translateX(-80%);} /* 24s/30s*100 */  

    /* Image 5 (duplicate of Image 1): End hold at 29s, Infinite reset at 30s */
    96.67% {transform: translateX(-80%);} /* 29s/30s*100 */   

    100% {transform: translateX(-80%);}  /* 30s/30s*100 */

 }

}


/* for Phone */
@media (max-width:700px) {
    
/* 3rd Container */
  .container-3 {
    display: grid;
    grid-template-columns: 2fr 1fr 0.1fr;
    background-color: rgb(238, 238, 238);
    height: 25vw;
    margin-top: 0.7rem;
  }

  .text-spicy-bowls {
    cursor: pointer;
    border: none;
    outline: none;
    color: darkblue;
    font-style: optima;
    font-size: 1.05rem;
    font-weight: bold;
    line-height: 0.5vw;
    margin-top: 6vw;
    margin-left: -30vw;
  }

  .text-japchae-tteokbokki {
    cursor: pointer;
    border: none;
    outline: none;
    color: darkblue;
    font-style: optima;
    font-size: 1.05rem;
    font-weight: bold;
    line-height: 0.5vw;
    margin-top: 2vw;
    margin-left: 5vw;
  }


  .text-jjigae {
    cursor: pointer;
    border: none;
    outline: none;
    color: darkblue;
    font-style: optima;
    font-size: 1.05rem;
    font-weight: bold;
    line-height: 0.5vw;
    margin-top: 2vw;
    margin-left: 10vw;
  }

.text-soup {
    cursor: pointer;
    border: none;
    outline: none;
    color: darkblue;
    font-style: optima;
    font-size: 1.05rem;
    font-weight: bold;
    line-height: 0.5vw;
    margin-top: 2vw;
    margin-left: 30vw;
  }


.container-3-right {
    place-items: center;    
    width: 80%;
    height: 25vw;
    margin: auto;
  }

  #slider {
    overflow: hidden;
  }

  #slider figure {
    position: relative;
    width: 500%;
    height: 100%;
    margin: 0;
    left: 0;
    object-fit: cover;
    animation: 30s slider infinite; 
  } 

  #slider figure img {
    float: left;
    width: 20%;  /* 100 / 5 including last image (dup of image1) */ 
    transform: translate3d(0, 0, 0); /* prevents potential flickering on some browsers */
    backface-visibility: hidden;
  }


@keyframes slider {

    /* Calculation: Each image is displayed for 5s (static) and move in 1s (transition)
       Total steps are 7 (including the duplicate), but we have 6 transitions
       Each image's stop point percentage is (index * 6s / 30s * 100%)
       Move point is (index * 6s - 1s / 30s * 100%)
    */

    /* image 1: End hold at 5s */
    0% {transform: translateX(0);}
    16.67% {transform: translateX(0);} /* 5s/30s*100, stay at 0% */
    20% {transform: translateX(-20%);} /* 6s/30s*100, move to image 2 */


    /* Image 2: End hold at 11s, move to image 3 at 12s */
    36.67% {transform: translateX(-20%);} /* 11s/30s*100 */
    40% {transform: translateX(-40%);} /* 12s/30s*100 */


    /* Image 3: End hold at 17s, move to image 4 at 18s */
    56.67% {transform: translateX(-40%);} /* 17s/30s*100 */
    60% {transform: translateX(-60%);} /* 18s/30s*100 */

    /* Image 4: End hold at 23s, move to image 5 at 24s */
    76.67% {transform: translateX(-60%);} /* 23s/30s*100 */
    80% {transform: translateX(-80%);} /* 24s/30s*100 */  

    /* Image 5 (duplicate of Image 1): End hold at 29s, Infinite reset at 30s */
    96.67% {transform: translateX(-80%);} /* 29s/30s*100 */   

    100% {transform: translateX(-80%);}  /* 30s/30s*100 */

 }

}

</style>